import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IFlight } from '../../../../model/flights';
import { FlightsService } from '../flights.service';
import { EnvService } from './../../configuration/env.service';
import { LocationContextService } from './../../location-context/location-context.service';

@Component({
    selector: 'app-flights',
    templateUrl: './flights.component.html',
    styleUrls: ['./flights.component.scss']
})
export class FlightsComponent implements OnInit, OnDestroy {
    LOG_SOURCE = 'FlightsComponent';
    sub: Subscription;
    showFlights = false;
    flights: IFlight[];

    constructor(
        private readonly flightsService: FlightsService,
        private readonly locationContextService: LocationContextService,
        private readonly env: EnvService
    ) {}

    ngOnInit() {
        this.showFlights = this.env.config.flights.show;
        if (this.showFlights) {
            this.sub = this.flightsService.getFlights().subscribe(flights => {
                this.flights = flights;
            });
        }
    }

    getFlightTypeIconName(flight: IFlight): string {
        return this.flightsService.getFlightTypeIconName(flight?.flightType);
    }

    isGreyedOut(flight: IFlight): boolean {
        return flight.stand !== this.locationContextService.getSelectedCenterline();
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
